<div class="ol-map relative" [id]="id">
  <ng-content select="[ol-map-header]"></ng-content>

  <ng-content select="[ol-map-left-sidebar]"></ng-content>

  <ng-content select="[ol-map-right-sidebar]"></ng-content>

  <ng-content select="[ol-map-footer]"></ng-content>
</div>
